import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space8
  },

  voucherIconWrapper: {
    width: 60,
    height: 60,
    borderRadius: theme.radius.xmedium,
    overflow: "hidden",
    background: theme.colors.Background3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    color: theme.colors.TextGray,
    textAlign: "center"
  },
}));